import styled from 'styled-components'

export const Svg = styled.svg`
  display: inline-block;
  stroke: currentColor;
  fill: currentColor;
  width: ${ (props) => props.width }px;
  height: ${ (props) => props.height }px;

  @media ${ (props) => props.theme.breakpoints.devices.min.md }, print {
    width: ${ (props) => props.width - 1 }px;
    height: ${ (props) => props.height - 1 }px;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.lg }, print {
    width: ${ (props) => props.width }px;
    height: ${ (props) => props.height }px;
  }
`
